import { Tab } from 'semantic-ui-react';
import DueAmounts from './DueAmounts';
import CurrentPosition from './CurrentPosition';
import BillingPeriodSelector from './BillingPeriodSelector';
import RecommendedExtraPaymentOptOutOptions from './RecommendedExtraPaymentOptOutOptions';
import AllocatedTransactions from './transaction/AllocatedTransactions';
import BillingPeriodSummary from './BillingPeriodSummary';
import ReageAdjustments from './ReageAdjustments';
import AlternateMinimumDueArrangement from './AlternateMinimumDueArrangements';
import {
  AnnualStatementSelector,
  AnnualStatements,
  BillingPeriodStatementSelector,
  BillingPeriodStatements,
} from './statement/Statement';
import NosiaOverview from './delinquency/NosiaOverview';
import NosiaSelector from './delinquency/NosiaSelector';
import PersistentDebt from './delinquency/PersistentDebt';
import AccrualsSummary from './accruals/AccrualsSummary';
import EncourageCustomerToPayMore from './EncourageCustomerToPayMore';

export default function Billing() {
  const panes = [
    {
      menuItem: 'Billing Periods',
      render: () => (
        <Tab.Pane>
          <BillingPeriodSelector />
          <BillingPeriodSummary />
          <AllocatedTransactions />
        </Tab.Pane>
      ),
    },
    {
      menuItem: 'Alternate Minimum Due Arrangements',
      render: () => (
        <Tab.Pane>
          <AlternateMinimumDueArrangement />
        </Tab.Pane>
      ),
    },
    {
      menuItem: 'Statements',
      render: () => (
        <Tab.Pane>
          <BillingPeriodStatementSelector />
          <BillingPeriodStatements />
        </Tab.Pane>
      ),
    },
    {
      menuItem: 'Annual Statements',
      render: () => (
        <Tab.Pane>
          <AnnualStatementSelector />
          <AnnualStatements />
        </Tab.Pane>
      ),
    },
    {
      menuItem: 'NOSIA',
      render: () => (
        <Tab.Pane>
          <NosiaSelector />
          <NosiaOverview />
        </Tab.Pane>
      ),
    },
    {
      menuItem: 'Persistent Debt',
      render: () => (
        <Tab.Pane>
          <PersistentDebt />
        </Tab.Pane>
      )
    },
    {
      menuItem: 'Accruals',
      render: () => (
        <Tab.Pane>
          <BillingPeriodSelector />
          <AccrualsSummary />
        </Tab.Pane>
      )
    },
    {
      menuItem: 'Recommended Extra Payment',
      render: () => (
        <Tab.Pane>
          <RecommendedExtraPaymentOptOutOptions/>
        </Tab.Pane>
      )
    }
  ];
  return (
    <section>
      <div className="ui grid">
        <div className="three wide column">
          <div className="ui cards">
            <DueAmounts />
            <CurrentPosition />
            <EncourageCustomerToPayMore />
            <ReageAdjustments />
          </div>
        </div>
        <div className="thirteen wide column">
          <Tab panes={panes} />
        </div>
      </div>
    </section>
  );
}
